import React from "react";
import Swal from "sweetalert2";
import DynamicForm from "../../../../data/Axios/DynamicForm";
import { HRService } from "../../../../config";
import {
  generateAndExecuteMutation,
} from "../../../../data/Axios/DynamicService";

const base_url = HRService.uri;

const LevelForm = (props) => {
  const initialValues = {
    name: props.data ? props.data.name : "",
  };

  const fields = [
    {
      name: "name",
      label: "Level Name",
      type: "text",
      required: true,
      gridColumn: "span 2",
    },
  ];

  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
      const userId = decodedToken?.Id ? parseInt(decodedToken.Id) : null;

      const mutationData = {
        id: props.isEditing ? props.data.id : 0,
        name: values.name,
        createdBy: props.isEditing ? null : userId,
        updatedBy: props.isEditing ? userId : null,
      };

      const mutationName = props.isEditing ? "updateLevel" : "createLevels";

      const response = await generateAndExecuteMutation(
        mutationName,
        mutationData,
        "level",
        base_url
      );

      if (Object.values(response)[0] != null) {
        props.onClose();
        props.onAction();
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: props.isEditing
            ? "Level updated successfully."
            : "Level created successfully.",
        });
      }
    } catch (error) {
      console.error("Error submitting Level:", error);
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "An error occurred while processing your request. Please try again later.",
      });
    }

    setSubmitting(false);
  };

  return (
    <DynamicForm
      initialValues={initialValues}
      fields={fields}
      steps={[{
        stepNumber: 1,
        stepLabel: "level",
        stepDescription: "Enter level information",
        fields: fields.map(f => f.name),
      }]}
      onSubmit={handleSubmit}
      title={props.isEditing ? "Update Level" : "Create Level"}
      subtitle={
        props.isEditing
          ? "Update existing level details."
          : "Fill out the form below to create a new level."
      }
    />
  );
};

export default LevelForm;
